import {
  SET_GOAL,
  SET_SAVINGS_PLAN_ID,
  SET_SAVINGS_PLAN_SUCCESS,
  SET_LOADING,
  GET_QUESTIONS_BY_GOAL_TYPE_SUCCESS,
  GET_QUESTIONS_BY_GOAL_TYPE_FAIL,
  GET_SAVINGS_PLAN_SUCCESS,
  GET_SAVINGS_PLAN_FAIL,
  RESET_SAVINGS_PLAN,
  SET_PROGRAM_DURATION,
  SET_PROGRAM_COST,
  GET_USER_ACCOUNT_DETAILS,
  GET_USER_ACCOUNT_DETAILS_FAIL,
  SET_USER_ACCOUNT_DETAILS,
  SET_USER_ACCOUNT_DETAILS_FAIL,
  RESET_USER_ACCOUNT_DETAILS,
  GET_USER_GOALS,
  GET_USER_GOAL_FAIL,
  SET_USER_FINANCIAL_ADVISOR_MAIL,
  DELETE_USER_GOAL,
  DELETE_USER_GOAL_FAIL,
  SET_GOAL_TO_LAUNCH,
  RESET_GOAL_TO_LAUNCH,
  SET_GOAL_TO_LAUNCH_FAIL,
  SET_ID,
  SET_USER_ACCEPTED_TERMS,
  SET_USER_ACCEPTED_TERMS_FAIL,
  SUBMIT_USER_ANSWER_SUCCESS,
  SUBMIT_USER_ANSWER_FAIL,
  ADD_OTHER_CUSTODIANS_FAIL,
  ADD_OTHER_CUSTODIANS_SUCCESS,
  RESET_CUSTODIANS_SUCCESS,
  SET_GOAL_TO_LAUNCH_PAYLOAD,
  ADD_CUSTODIAN_TYPE_SUCCESS,
  ADD_CUSTODIAN_TYPE_FAIL,
  GET_NEW_DASHBOARD_INFORMATION_SUCCESS,
  GET_NEW_DASHBOARD_INFORMATION_FAIL,
  GET_INDIVIDUAL_FORM_FAIL,
  GET_INDIVIDUAL_FORM_SUCCESS,
  POST_INDIVIDUAL_FORM,
  POST_INDIVIDUAL_FORM_FAIL,
  POST_JOINT_FORM,
  POST_JOINT_FORM_FAIL,
  POST_RIA_FORM,
  POST_RIA_FORM_FAIL,
  GET_CONTACT_INFORMATION,
  GET_CONTACT_INFORMATION_FAIL,
  POST_VERIFICATION_FORM,
  POST_VERIFICATION_FORM_FAIL,
  ESTABLISH_SSO_CONNECTION_SUCCESS,
  ESTABLISH_SSO_CONNECTION_FAIL,
  RESET_ESTABLISH_SSO_CONNECTION_SUCCESS,
  RESET_ALL_FORM_DATA,
  RESET_VERIFICATION_FORM,
  GET_TRANSFER_GOALS_SUCCESS,
  GET_TRANSFER_GOALS_FAIL,
  SET_TRANSFER_GOALS_SUCCESS,
  SET_TRANSFER_GOALS_FAIL,
  RESET_TRANSFER_GOALS_SUCCESS,
  GET_ADVISOR_NAME,
  GET_ADVISOR_NAME_FAIL,
  RESET_ADVISOR_NAME,
  RESET_NEW_DASHBOARD_INFORMATION,
  SET_GOAL_RENAME,
  SIGN_ADVISORY_SUCCESS,
  SIGN_ADVISORY_FAIL,
  GET_ACCOUNT_OVERVIEW_SUCCESS,
  GET_ACCOUNT_OVERVIEW_FAIL,
  RESET_DASHBOARD_DATA,
  SET_LOGIN_SUCCESS_RESPONSE,
  GET_DOCUMENTS,
  RESET_QA,
  SET_FIRST_LOGIN,
  RESET_INDIVIDUAL_INFORMATION,
  RESET_JOINT_INFORMATION,
  RESET_RIA_INFORMATION,
  GET_IBKR_DEPOSIT_FUNDS_URL_SUCCESS,
  GET_IBKR_DEPOSIT_FUNDS_URL_FAIL,
  GET_LIST_OF_ADVISORS_SUCCESS,
  GET_LIST_OF_ADVISORS_FAIL,
  GET_ADVISOR_CLIENT_DETAILS_SUCCESS,
  GET_ADVISOR_CLIENT_DETAILS_FAIL,
  RESET_CLIENT_SUMMARRY_DATA,
  RESET_ADVISOR_DETAILS_DATA,
  GET_ADVISOR_DETAILS_SUCCESS,
  GET_ADVISOR_DETAILS_FAIL,
  GET_INDIVIDUAL_ACCOUNT_NOTES_SUCCESS,
  RESET_INDIVIDUAL_ACCOUNT_NOTES,
  GET_INDIVIDUAL_ACCOUNT_NOTES_FAIL,
  SET_ADVISOR_NOTE_SUCCESS,
  SET_ADVISOR_NOTE_FAIL,
  GET_INDIVIDUAL_ACCOUNT_DETAILS_SUCCESS,
  GET_INDIVIDUAL_ACCOUNT_DETAILS_FAIL,
  GET_INVITE_CLIENT_ADVISOR_LIST_SUCCESS,
  GET_INVITE_CLIENT_ADVISOR_LIST_FAIL,
  INVITE_CLIENT_SUCCESS,
  INVITE_CLIENT_FAIL,
  GET_LIST_OF_INCOMING_ADVISORS_SUCCESS,
  GET_LIST_OF_INCOMING_ADVISORS_FAIL,
  SET_FILTER_SAVE_CLICK,
  SET_FILTER_CLEAR_CLICK,
  RESET_FILTER_CLICK,
  APPLY_FILTER_CLIENT_LIST_TABLE,
  GET_INCOMING_CLIENT_DETAILS_SUCCESS,
  GET_CUSTODIANS_FILTER_SUCCESS,
  GET_CUSTODIANS_FILTER_FAIL,
  GET_RIAS_FILTER_SUCCESS,
  GET_RIAS_FILTER_FAIL,
  GET_ADVISORS_FILTER_SUCCESS,
  GET_ADVISORS_FILTER_FAIL,
  GET_BENCHMARK_DATA_SUCCESS,
  GET_BENCHMARK_DATA_FAIL,
  APPLY_FILTER_INCOMING_CLIENT_LIST_TABLE,
  GET_LIST_OF_FIRM_CLIENTS_SUCCESS,
  GET_LIST_OF_FIRM_CLIENTS_FAIL,
  GET_RECENTLY_FUNDED_ACCOUNT_REPORT_SUCCESS,
  GET_RECENTLY_FUNDED_ACCOUNT_REPORT_FAIL,
  GET_EDIT_FIRM_CLIENT_DETAILS_SUCCESS,
  RESET_EDIT_CLIENT_FARM,
  GET_RECENTLY_REGISTERED_ACCOUNT_REPORT_SUCCESS,
  DELETE_ADVISOR_PORTAL_USER_SUCCESS,
  DELETE_ADVISOR_PORTAL_USER_FAIL,
  GET_COMPANY_LOGO_SUCCESS,
  GET_COMPANY_LOGO_FAIL,
  GET_RIAS_FOR_ADVISOR_SUCCESS,
  GET_RIAS_FOR_ADVISOR_FAIL,
  GET_ROLES_FOR_ADVISOR_SUCCESS,
  FIRM_ADD_USER_SUCCESSFUL,
  RESET_ADD_ADVISOR_PORTAL_USER,
  GET_LIST_OF_FIRM_CLIENTS_BY_FIRM_ID_SUCCESS,
  RESET_DELETE_ADVISOR_PORTAL_USER_SUCCESS,
  GET_ASSET_UNDER_MANAGEMENT_SUCCESS,
  GET_TOP_CLIENTS_SUCCESS,
  GET_TOP_CLIENTS_FAIL,
  GET_DASHBOARD_RELATIONSHIPS_SUCCESS,
  GET_DASHBOARD_RELATIONSHIPS_FAIL,
  GET_MASTER_ACCOUNTS_SUCCESS,
  GET_MASTER_ACCOUNTS_FAIL,
  ADD_MASTER_ACCOUNTS_SUCCESS,
  ADD_MASTER_ACCOUNTS_FAIL,
  REMOVE_MASTER_ACCOUNTS_SUCCESS,
  REMOVE_MASTER_ACCOUNTS_FAIL,
  RESET_MASTER_ACCOUNTS
} from "./action-types";
//import { mapTypeToNumber } from "../utils";
import { getAccessToken } from "./cookie";

let apiEndpoint = "";

if (process.env.REACT_APP_BUILD_ENV === "dev") {
  apiEndpoint = process.env.REACT_APP_API_AMAZONAWS_DEV;
} else if (process.env.REACT_APP_BUILD_ENV === "test") {
  apiEndpoint = process.env.REACT_APP_API_AMAZONAWS_TEST;
} else if (process.env.REACT_APP_BUILD_ENV === "demo") {
  apiEndpoint = process.env.REACT_APP_API_AMAZONAWS_DEMO;
} else if (process.env.REACT_APP_BUILD_ENV === "prod") {
  apiEndpoint = process.env.REACT_APP_API_AMAZONAWS_PROD;
}

export const setGoal = (goal) => {
  return async (dispatch) => {
    dispatch({ type: SET_GOAL, payload: goal });
  };
};

export const resetOnClickFilter = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_FILTER_CLICK });
  };
};

export const resetDeleteAdvisorPortalUser = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_DELETE_ADVISOR_PORTAL_USER_SUCCESS });
  };
};

export const resetEditClientFarmDetails = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_EDIT_CLIENT_FARM });
  };
};

export const resetAddAdvisorPortalUser = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_ADD_ADVISOR_PORTAL_USER });
  };
};

export const onClickFilterSave = (filterColumn) => {
  return async (dispatch) => {
    dispatch({ type: SET_FILTER_SAVE_CLICK, payload: filterColumn });
  };
};

export const applyFilterInMyClientsTable = (filterData) => {
  return async (dispatch) => {
    dispatch({
      type: APPLY_FILTER_CLIENT_LIST_TABLE,
      payload: filterData,
    });
  };
};

export const applyFilterInIncomingClientsTable = (filterData) => {
  return async (dispatch) => {
    dispatch({
      type: APPLY_FILTER_INCOMING_CLIENT_LIST_TABLE,
      payload: filterData,
    });
  };
};

export const onClickFilterClear = (filterColumn) => {
  return async (dispatch) => {
    dispatch({ type: SET_FILTER_CLEAR_CLICK, payload: filterColumn });
  };
};

export const setGoalToLaunchPayload = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_GOAL_TO_LAUNCH_PAYLOAD, payload: payload });
  };
};

export const setLoginSuccessResponse = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOGIN_SUCCESS_RESPONSE, payload: payload });
  };
};

export const setId = (mailId, password) => {
  return async (dispatch) => {
    dispatch({
      type: SET_ID,
      payload: { mailId, password },
    });
  };
};

export const getStepsByGoal = ({ type, link }) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Question/Questionnaire`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          goalType: type.replace(" ", ""),
          goalId: link === undefined ? null : link,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_QUESTIONS_BY_GOAL_TYPE_SUCCESS,
          payload: data.questionnaireSteps,
        });
        dispatch({ type: SET_GOAL, payload: { id: data.goalId, type, link } });
        return data;
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_QUESTIONS_BY_GOAL_TYPE_FAIL, payload: err });
    }
  };
};

export const editClientFirmDetails = (
  userId,
  firstName,
  lastName,
  email,
  phoneNo
) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Firm/Client`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          userId: userId,
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNo,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_EDIT_FIRM_CLIENT_DETAILS_SUCCESS,
          payload: data,
        });
        return data;
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({
        type: GET_RECENTLY_FUNDED_ACCOUNT_REPORT_FAIL,
        payload: err,
      });
    }
  };
};

export const getRecentlyRegisteredAccountReport = (pageNumber, pageSize) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/IncomingClients/RecentlyRegisteredReport`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          pageNumber: pageNumber,
          pageSize: pageSize,
          searchValue: "",
          sortingItems: [],
          filters: [],
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_RECENTLY_REGISTERED_ACCOUNT_REPORT_SUCCESS,
          payload: data,
        });
        return data;
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({
        type: GET_RECENTLY_FUNDED_ACCOUNT_REPORT_FAIL,
        payload: err,
      });
    }
  };
};

export const getRecentlyFundedAccountReport = (pageNumber, pageSize) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/MyClients/RecentlyFundedAcctReport`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          pageNumber: pageNumber,
          pageSize: pageSize,
          searchValue: "",
          sortingItems: [],
          filters: [],
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_RECENTLY_FUNDED_ACCOUNT_REPORT_SUCCESS,
          payload: data,
        });
        return data;
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({
        type: GET_RECENTLY_FUNDED_ACCOUNT_REPORT_FAIL,
        payload: err,
      });
    }
  };
};

export const getListOfInvestors = (
  pageNumber,
  pageSize,
  searchValue,
  sortingItems,
  filterData
) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/ListOfInvestors`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          pageNumber: pageNumber,
          pageSize: pageSize,
          searchValue: searchValue,
          sortingItems: sortingItems,
          filters: filterData,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_LIST_OF_ADVISORS_SUCCESS,
          payload: data,
        });
        return data;
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_LIST_OF_ADVISORS_FAIL, payload: err });
    }
  };
};

export const getListOfFirmClientsByFirmId = (
  pageNumber,
  pageSize,
  searchValue,
  sortingItems,
  filterData,
  firmId
) => {
  return async (dispatch) => {
    //const goalNum = mapTypeToNumber(type);
    const url = `${apiEndpoint}/Firm/${firmId}/ListOfClients`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          pageNumber: pageNumber,
          pageSize: pageSize,
          searchValue: searchValue,
          sortingItems: sortingItems,
          filters: filterData,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_LIST_OF_FIRM_CLIENTS_BY_FIRM_ID_SUCCESS,
          payload: data,
        });
        return data;
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_LIST_OF_FIRM_CLIENTS_FAIL, payload: err });
    }
  };
};

export const getListOfFirmClients = (
  pageNumber,
  pageSize,
  searchValue,
  sortingItems,
  filterData
) => {
  return async (dispatch) => {
    //const goalNum = mapTypeToNumber(type);
    const url = `${apiEndpoint}/Firm/ListOfClients`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          pageNumber: pageNumber,
          pageSize: pageSize,
          searchValue: searchValue,
          sortingItems: sortingItems,
          filters: filterData,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_LIST_OF_FIRM_CLIENTS_SUCCESS,
          payload: data,
        });
        return data;
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_LIST_OF_FIRM_CLIENTS_FAIL, payload: err });
    }
  };
};

export const getListOfIncomingInvestors = (
  pageNumber,
  pageSize,
  searchValue,
  sortingItems,
  filterData
) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/ListOfIncomingInvestors`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          pageNumber: pageNumber,
          pageSize: pageSize,
          searchValue: searchValue,
          sortingItems: sortingItems,
          filters: filterData,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_LIST_OF_INCOMING_ADVISORS_SUCCESS,
          payload: data,
        });
        return data;
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_LIST_OF_INCOMING_ADVISORS_FAIL, payload: err });
    }
  };
};

export const submitQA = (data) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/UserQA`;
    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: SUBMIT_USER_ANSWER_SUCCESS,
          payload: data,
        });
        return;
      } else {
        const data = await response.json();
        dispatch({
          type: SUBMIT_USER_ANSWER_FAIL,
          payload: data,
        });
        return new Error("error de peticion");
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const inviteClient = (data) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/InviteClient`;
    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        // const data = await response.json();
        dispatch({
          type: INVITE_CLIENT_SUCCESS,
          payload: response,
        });
        return response;
      } else {
        // const data = await response.json();
        dispatch({
          type: INVITE_CLIENT_FAIL,
          payload: response,
        });
        return new Error("error");
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const resetQA = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_QA });
  };
};

export const resetSavingsPlan = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_SAVINGS_PLAN,
    });
  };
};

export const resetAdvisorNote = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_INDIVIDUAL_ACCOUNT_NOTES,
    });
  };
};

export const resetAdvisorName = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_ADVISOR_NAME,
    });
  };
};

export const resetSetTransferGoal = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_TRANSFER_GOALS_SUCCESS,
    });
  };
};

export const resetAllFormData = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_ALL_FORM_DATA,
    });
  };
};

export const resetVerificationForm = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_VERIFICATION_FORM,
    });
  };
};

export const resetNewDashboardInformation = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_NEW_DASHBOARD_INFORMATION,
    });
  };
};

export const reset = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_NEW_DASHBOARD_INFORMATION,
    });
  };
};

export const resetClientSummaryData = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_CLIENT_SUMMARRY_DATA,
    });
  };
};

export const resetAdvisorData = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_ADVISOR_DETAILS_DATA,
    });
  };
};

export const resetMasterAccounts = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_MASTER_ACCOUNTS,
    });
  };
};

export const getSavingsPlan = ({ goalId }) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/SavingsPlan`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({ goalId }),
      });

      const data = await response.json();
      dispatch({
        type: SET_SAVINGS_PLAN_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_SAVINGS_PLAN_FAIL,
        payload: err,
      });
    }
  };
};

export const postAdvisorNote = (investorId, note) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Investor/Notes`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          investorId: investorId,
          message: note,
        }),
      });

      const data = await response.json();
      dispatch({
        type: SET_ADVISOR_NOTE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: SET_ADVISOR_NOTE_FAIL,
        payload: err,
      });
    }
  };
};

export const firmAddUser = (
  firstName,
  lastName,
  email,
  phoneNo,
  riaId,
  role,
  masterAccounts
) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/Firm/AddUser`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          firstName: firstName,
          lastName: lastName,
          email: email,
          phoneNumber: phoneNo,
          userType: role,
          riaId: riaId,
          masterAccounts: masterAccounts,
        }),
      });

      const data = await response.json();
      dispatch({
        type: FIRM_ADD_USER_SUCCESSFUL,
        payload: data,
      });
      return data;
    } catch (err) {
      dispatch({
        type: SIGN_ADVISORY_FAIL,
        payload: err,
      });
      return err;
    }
  };
};

export const signAdvisoryAgreement = (signature) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/User/SubmissionData/${signature}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();
      dispatch({
        type: SIGN_ADVISORY_SUCCESS,
        payload: data,
      });
      return data;
    } catch (err) {
      dispatch({
        type: SIGN_ADVISORY_FAIL,
        payload: err,
      });
      return err;
    }
  };
};

export const getRolesForAdvisor = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Firm/Roles`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_ROLES_FOR_ADVISOR_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_RIAS_FOR_ADVISOR_FAIL,
        payload: err,
      });
    }
  };
};

export const getRIAsForAdvisor = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/RIAs`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_RIAS_FOR_ADVISOR_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_RIAS_FOR_ADVISOR_FAIL,
        payload: err,
      });
    }
  };
};

export const addMasterAccountToAdvisor = (payload) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Firm/Advisor/MasterAccount`;
    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      dispatch({
        type: ADD_MASTER_ACCOUNTS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: ADD_MASTER_ACCOUNTS_FAIL,
        payload: err,
      });
    }
  };
};

export const removeMasterAccounts = (id) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Firm/Advisor/MasterAccounts/${id}`;
    try {
      const response = await fetch(url, {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: REMOVE_MASTER_ACCOUNTS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: REMOVE_MASTER_ACCOUNTS_FAIL,
        payload: err,
      });
    }
  };
};

export const getMasterAccounts = (emailId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Firm/Advisor/MasterAccounts/${emailId}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_MASTER_ACCOUNTS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_MASTER_ACCOUNTS_FAIL,
        payload: err,
      });
    }
  };
};

export const getCustodiansForFilter = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/Custodians`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_CUSTODIANS_FILTER_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_CUSTODIANS_FILTER_FAIL,
        payload: err,
      });
    }
  };
};

export const getCompanyLogo = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/CompanyLogo`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_COMPANY_LOGO_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_COMPANY_LOGO_FAIL,
        payload: err,
      });
    }
  };
};

export const getRIAsForFilter = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/RIAs`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_RIAS_FILTER_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_RIAS_FILTER_FAIL,
        payload: err,
      });
    }
  };
};

export const getDashboardRelationships = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/Dashboard/Charts`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_DASHBOARD_RELATIONSHIPS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_DASHBOARD_RELATIONSHIPS_FAIL,
        payload: err,
      });
    }
  };
};

export const getDashboardTopClients = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/Dashboard/TopClients`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_TOP_CLIENTS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_TOP_CLIENTS_FAIL,
        payload: err,
      });
    }
  };
};

export const getAssetUnderManagementGraph = (option = "default") => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/Dashboard/AssetsUnderManagmentGraph/${option}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_ASSET_UNDER_MANAGEMENT_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_BENCHMARK_DATA_FAIL,
        payload: err,
      });
    }
  };
};

export const getBenchmarkData = (option = "default") => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/IBDocuments/BanchmarkData/${option}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_BENCHMARK_DATA_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_BENCHMARK_DATA_FAIL,
        payload: err,
      });
    }
  };
};

export const getAdvisorsForFilter = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/Advisors`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_ADVISORS_FILTER_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_ADVISORS_FILTER_FAIL,
        payload: err,
      });
    }
  };
};

export const getInviteClientAdvisorList = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/InviteClient/Advisors`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_INVITE_CLIENT_ADVISOR_LIST_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_INVITE_CLIENT_ADVISOR_LIST_FAIL,
        payload: err,
      });
    }
  };
};

export const getDashboardInformation = (goalId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/savingsPlan/DashboardInformation/${goalId}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const { dashboardContent, savingsPlanId } = await response.json();

      dispatch({
        type: GET_SAVINGS_PLAN_SUCCESS,
        payload: dashboardContent,
      });
      dispatch({
        type: SET_SAVINGS_PLAN_ID,
        payload: savingsPlanId,
      });
    } catch (err) {
      dispatch({
        type: GET_SAVINGS_PLAN_FAIL,
        payload: err,
      });
    }
  };
};

export const advisorClientDetailsAction = (clientId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/Clients/${clientId}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_ADVISOR_CLIENT_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_ADVISOR_CLIENT_DETAILS_FAIL,
        payload: err,
      });
    }
  };
};

export const individualAccountDetailsAction = (userId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/${userId}/Accounts`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_INDIVIDUAL_ACCOUNT_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_INDIVIDUAL_ACCOUNT_DETAILS_FAIL,
        payload: err,
      });
    }
  };
};

export const advisorDetailsAction = (advisorId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/${advisorId}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_ADVISOR_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_ADVISOR_DETAILS_FAIL,
        payload: err,
      });
    }
  };
};

export const incomingClientDetailsAction = (goalId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Advisor/IncomingClientDetails/${goalId}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_INCOMING_CLIENT_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_ADVISOR_DETAILS_FAIL,
        payload: err,
      });
    }
  };
};

export const getAccountOverviewInformation = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/IBDocuments/Dashboard/AccountOverview`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_ACCOUNT_OVERVIEW_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_ACCOUNT_OVERVIEW_FAIL,
        payload: err,
      });
    }
  };
};

export const getIndividualAccountNotes = (investorId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Investor/Notes/${investorId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_INDIVIDUAL_ACCOUNT_NOTES_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_INDIVIDUAL_ACCOUNT_NOTES_FAIL,
        payload: err,
      });
    }
  };
};

export const getIBKRDepositFundsURL = (goalId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Goal/${goalId}/IBKRDepositFundsURL`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      dispatch({
        type: GET_IBKR_DEPOSIT_FUNDS_URL_SUCCESS,
        payload: data,
      });

      return data;
    } catch (err) {
      dispatch({
        type: GET_IBKR_DEPOSIT_FUNDS_URL_FAIL,
        payload: err,
      });
    }
  };
};

export const getIBKRTransferFundsURL = (goalId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Goal/${goalId}/IBKRTransferFundsURL`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      return data;
    } catch (err) {
      return err;
    }
  };
};

export const getIBKRStatementsURL = (goalId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Goal/${goalId}/IBKRStatementsURL`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const data = await response.json();

      return data;
    } catch (err) {
      return err;
    }
  };
};

export const getNewDashboardInformation = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/IBDocuments/Dashboard/ListOfGoals`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      const dashboardContent = await response.json();
      dispatch({
        type: GET_NEW_DASHBOARD_INFORMATION_SUCCESS,
        payload: dashboardContent,
      });
    } catch (err) {
      dispatch({
        type: GET_NEW_DASHBOARD_INFORMATION_FAIL,
        payload: err,
      });
    }
  };
};

export const updateSavingsPlan = ({ data }) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/YourGoalCalculation`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        console.log("inside in if");
      } else {
        console.log("error in else");
        dispatch({
          type: GET_SAVINGS_PLAN_FAIL,
          payload: await response.json(),
        });
        return;
      }

      const { dashboardContent } = await response.json();
      dispatch({
        type: GET_SAVINGS_PLAN_SUCCESS,
        payload: dashboardContent,
      });
    } catch (err) {
      console.log("error - ", err);
      dispatch({
        type: GET_SAVINGS_PLAN_FAIL,
        payload: err,
      });
    }
  };
};

export const setProgramDuration = (duration) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRAM_DURATION, payload: duration });
  };
};

export const setProgramCost = (cost) => {
  return async (dispatch) => {
    dispatch({ type: SET_PROGRAM_COST, payload: cost });
  };
};

export const getUserAccountDetails = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/User`;
    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_USER_ACCOUNT_DETAILS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_USER_ACCOUNT_DETAILS_FAIL, payload: err });
    }
  };
};

export const resetUserAccountDetails = () => {
  return async (dispatch) => {
    dispatch({
      type: RESET_USER_ACCOUNT_DETAILS,
    });
  };
};

export const saveUserAccountDetails = (userDetails) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/User`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(userDetails),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: SET_USER_ACCOUNT_DETAILS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: SET_USER_ACCOUNT_DETAILS_FAIL, payload: err });
    }
  };
};

export const setIsUserAcceptedTerms = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/User/UserAgreement/true`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: SET_USER_ACCEPTED_TERMS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: SET_USER_ACCEPTED_TERMS_FAIL, payload: err });
    }
  };
};

export const setUserSignupedData = (mailId, token) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/Contact`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          email: mailId,
        }),
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: "",
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: SET_USER_ACCOUNT_DETAILS_FAIL, payload: err });
    }
  };
};

export const getUserGoal = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/Goal/UserGoals`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: GET_USER_GOALS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_USER_GOAL_FAIL, payload: err });
    }
  };
};

export const getTransferFundsGoal = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/IBDocuments/Dashboard/Manage/TransferFunds`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: GET_TRANSFER_GOALS_SUCCESS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_TRANSFER_GOALS_FAIL, payload: err });
    }
  };
};

export const getAdvisorName = (goalId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/Goal/${goalId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: GET_ADVISOR_NAME,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_ADVISOR_NAME_FAIL, payload: err });
    }
  };
};

export const transferGoal = (goalId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/IBHandler/EstablishSSOConnection/${goalId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: SET_TRANSFER_GOALS_SUCCESS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: SET_TRANSFER_GOALS_FAIL, payload: err });
    }
  };
};

export const setUserFinancialAdvisorMailId = (mailId, goalId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/Goal/${goalId}/${mailId}`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: SET_USER_FINANCIAL_ADVISOR_MAIL,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_USER_GOAL_FAIL, payload: err });
    }
  };
};

export const deleteAdvisorPortalUser = (userId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Firm/Client/${userId}`;

    try {
      const response = await fetch(url, {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });
      if (response.ok) {
        const data = { response: "success" };
        dispatch({
          type: DELETE_ADVISOR_PORTAL_USER_SUCCESS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: DELETE_ADVISOR_PORTAL_USER_FAIL, payload: err });
    }
  };
};

export const deleteGoal = (goalId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Goal/${goalId}`;

    try {
      const response = await fetch(url, {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });
      if (response.ok) {
        const data = { response: "success" };
        dispatch({
          type: DELETE_USER_GOAL,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: DELETE_USER_GOAL_FAIL, payload: err });
    }
  };
};

export const setGoalToLaunch = (payload) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/Goal/ChangeStatusToLaunched`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        //const data = await response.json();

        dispatch({
          type: SET_GOAL_TO_LAUNCH,
          payload: response,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: SET_GOAL_TO_LAUNCH_FAIL, payload: err });
    }
  };
};

export const resetGoalToLaunch = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_GOAL_TO_LAUNCH });
  };
};

export const resetCustodian = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_CUSTODIANS_SUCCESS });
  };
};

export const addOtherCustodians = (custodianName, goalId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/Goal/CustodianName`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          goalId: goalId,
          custodianName: custodianName,
        }),
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: ADD_OTHER_CUSTODIANS_SUCCESS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: ADD_OTHER_CUSTODIANS_FAIL, payload: err });
    }
  };
};

export const addCustodianType = (custodianType, goalId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    const url = `${apiEndpoint}/Goal/IBAccountType`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify({
          goalId: goalId,
          ibAccountType: custodianType,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: ADD_CUSTODIAN_TYPE_SUCCESS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: ADD_CUSTODIAN_TYPE_FAIL, payload: err });
    }
  };
};

export const getIndividualForm = (goalId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/IBHandler/ExistingData/${goalId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: GET_INDIVIDUAL_FORM_SUCCESS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: GET_INDIVIDUAL_FORM_FAIL, payload: err });
    }
  };
};

export const resetEstablishSSOConnection = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_ESTABLISH_SSO_CONNECTION_SUCCESS });
  };
};

export const establishSSOConnectionAction = (goalId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/IBHandler/EstablishSSOConnection/${goalId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: ESTABLISH_SSO_CONNECTION_SUCCESS,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: ESTABLISH_SSO_CONNECTION_FAIL, payload: err });
    }
  };
};

export const postIndividualForm = (individualFormData) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/IBHandler/ContactInformation/Individual`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(individualFormData),
      });
      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: POST_INDIVIDUAL_FORM,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: POST_INDIVIDUAL_FORM_FAIL, payload: err });
    }
  };
};

export const postJointForm = (individualFormData) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/IBHandler/ContactInformation/Joint`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(individualFormData),
      });
      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: POST_JOINT_FORM,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: POST_JOINT_FORM_FAIL, payload: err });
    }
  };
};

export const postRiaForm = (individualFormData) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/IBHandler/ContactInformation/Retirement`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(individualFormData),
      });
      if (response.ok) {
        const data = await response.json();

        dispatch({
          type: POST_RIA_FORM,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: POST_RIA_FORM_FAIL, payload: err });
    }
  };
};

export const getContactInformation = (goalId) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/IBHandler/ContactInformation/${goalId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: GET_CONTACT_INFORMATION,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: GET_CONTACT_INFORMATION_FAIL, payload: err });
    }
  };
};

export const postVerificationForm = (goalId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const url = `${apiEndpoint}/IBHandler/AccountDetails/${goalId}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });
      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: POST_VERIFICATION_FORM,
          payload: data,
        });
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: POST_VERIFICATION_FORM_FAIL, payload: err });
    }
  };
};

export const setGoalRename = (goalInfo) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    const url = `${apiEndpoint}/IBDocuments/Dashboard/Goal/Rename`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(goalInfo),
      });
      if (response.ok) {
        console.log("OKII");
        const data = await response.json();
        dispatch({
          type: SET_GOAL_RENAME,
          payload: data,
        });
        dispatch({ type: SET_LOADING, payload: false });
      }
    } catch (error) {
      console.log("ERROR", error);
    }
  };
};

export const setUserAccountDetails = (userDetails) => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/User`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(userDetails),
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({
          type: SET_USER_ACCOUNT_DETAILS,
          payload: data,
        });

        try {
          const response = await fetch(url, {
            method: "GET",
            mode: "cors",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + getAccessToken(),
            },
          });

          if (response.ok) {
            const data = await response.json();
            dispatch({
              type: GET_USER_ACCOUNT_DETAILS,
              payload: data,
            });
          }
        } catch (err) {
          console.log(err);
          // Dispatch fail
          dispatch({ type: GET_USER_ACCOUNT_DETAILS_FAIL, payload: err });
        }
      }
    } catch (err) {
      console.log(err);
      // Dispatch fail
      dispatch({ type: SET_USER_ACCOUNT_DETAILS_FAIL, payload: err });
    }
  };
};

export const resetDashboardData = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_DASHBOARD_DATA });
  };
};

export const getDocuments = () => {
  return async (dispatch) => {
    const url = `${apiEndpoint}/Documents`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: GET_DOCUMENTS, payload: data });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: GET_DOCUMENTS, payload: error });
    }
  };
};

export const setFirstLogin = (firstLogin) => {
  return async (dispatch) => {
    dispatch({ type: SET_FIRST_LOGIN, payload: firstLogin });
  };
};

export const resetIndividualInformation = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_INDIVIDUAL_INFORMATION });
  };
};

export const resetJointInformation = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_JOINT_INFORMATION });
  };
};

export const resetRiaInformation = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_RIA_INFORMATION });
  };
};

export const getTemporaryCredentials = (goalId) => {
  return async () => {
    const url = `${apiEndpoint}/Goal/${goalId}/TemporaryCredentials`;

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.log(error);
      return new Error(error);
    }
  };
};
